import axios from './axios'

class RecordRepository {
  get (page) {
    return axios
      .get(`/records`, {
        params: {
          page: page
        }
      })
      .then((response) => {
        return response.data
      })
  }
  getForResultsPage () {
    return axios.get(`/records`).then((response) => {
      return response.data
    })
  }
  save (record) {
    return axios
      .put(`/records/${record.record_id}`, record)
      .then((response) => {
        return response.data
      })
  }

  remove (record) {
    return axios.delete(`/records/${record.record_id}`)
  }
}

export default new RecordRepository()



// WEBPACK FOOTER //
// ./src/data/record.repository.js